import Validate from 'validate-arguments';
import { forIn, forEach } from 'lodash';
var instance;
/**
 * @class Helper
 * @desc provides shared functionality
 */
var Helper = /** @class */ (function () {
    function Helper() {
        if (instance) {
            return instance;
        }
        instance = this;
        return instance;
    }
    /**
     * @desc validate-arguments - https://github.com/mvhenten/validate-arguments-js, validates function arguments, checks types and number of argument [supports not  mandatory arguments]
     * @param {Array} arg - method arguments
     * @param {Object} spec - object contains each argument description
     * @param {Object} spec.variableName - validation description
     * @throws error when arguments doesn't pass validation : error is generated by validate-arguments npm package
     * @example as param we expect string, param2 we expect boolean value (param is optional)
     * function testFunctionName(param, param2) {
     *  let spec = = {param: {isa : 'string'}, param2 : {isa: 'boolean', optional: true}};
     *
     * validateMethodParams(arguments, spec);
     *
     * }
     */
    Helper.prototype.validateMethodParams = function (arg, spec) {
        var _this = this;
        var paramsObj = {};
        var index = 0;
        forIn(spec, function (v, k) {
            if (arg.length < index) {
                return;
            }
            if (_this[v]) {
                spec[k] = _this[v];
            }
            paramsObj[k] = arg[index];
            index++;
        });
        var validateObject = Validate.named(paramsObj, spec);
        if (!validateObject.isValid()) {
            throw 'WRONG PARAMETERS: : ' + validateObject.errorString();
        }
    };
    /**
     * @desc add map with reference to custom objects
     */
    Helper.prototype.setCustomType = function (config) {
        var self = this;
        forEach(config, function (val, key) {
            self[key] = val;
        });
    };
    /**
     * @desc validate given string correspond to regexp
     */
    Helper.prototype.validateRegExp = function (regExp, stringToValidate) {
        var localRegExp = new RegExp(regExp);
        return localRegExp.test(stringToValidate);
    };
    /**
     * @desc return sorted array as floats
     */
    Helper.prototype.sortAsFloats = function (arr) {
        return arr
            .map(function (item) { return parseFloat(item); })
            .sort(function (curr, next) { return curr - next; });
    };
    /**
     * @desc return element index with given id
     */
    Helper.prototype.findIndexWithMatchingId = function (elements, id) {
        return elements === null || elements === void 0 ? void 0 : elements.findIndex(function (el) { return el.id === id; });
    };
    Helper.prototype.lowerCaseFirstLetter = function (value) {
        return value.charAt(0).toLowerCase() + value.slice(1);
    };
    Helper.prototype.prepareParamName = function (paramName) {
        return this.lowerCaseFirstLetter(paramName.replace('ID', 'Id'));
    };
    Helper.prototype.prepareParamValue = function (paramValue) {
        return paramValue === 'object' || (Array.isArray(paramValue) && paramValue)
            ? paramValue.toString()
            : paramValue;
    };
    return Helper;
}());
var helper = new Helper();
// export Helper singleton instance
export default helper;
